import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const MOVILIZATIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.MovilizationType.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
];

export const MOVILIZATIONTYPE_CONFIG = {
  entityName: 'MovilizationType',
  localizationKey: 'General::Entity.MovilizationType',
  fields: MOVILIZATIONTYPE_FIELDS,
  permission: 'GeneralMachinesAndVehicles.MovilizationTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
